import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getAccountInvoiceDetailsSectionStyles(theme: Theme) {
  return StyleSheet.create({
    section: {
      gap: 12,
    },
    sectionWithTopDivider: {
      paddingTop: 16,
      marginTop: 4,
      borderTopWidth: 1,
      borderTopColor: theme.gray[300],
    },
    title: {
      fontSize: 17,
      fontWeight: '800',
      color: theme.gray[900],
    },
    intro: {
      fontSize: 13,
      lineHeight: 19,
      color: theme.gray[600],
    },
    readOnlyRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 16,
      padding: 12,
      borderRadius: theme.borderRadius.md,
      borderWidth: 1,
      borderColor: theme.gray[300],
      backgroundColor: theme.background.cardElevated,
    },
    readOnlyItem: {
      gap: 2,
      minWidth: 120,
    },
    readOnlyLabel: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    readOnlyValue: {
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[800],
    },
    fieldGroup: {
      gap: 6,
    },
    label: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[700],
    },
    input: {
      borderWidth: 1,
      borderColor: theme.gray[300],
      borderRadius: theme.borderRadius.md,
      paddingHorizontal: 12,
      paddingVertical: Platform.OS === 'web' ? 10 : 12,
      fontSize: 15,
      color: theme.gray[900],
      backgroundColor: theme.background.cardElevated,
      ...(Platform.OS === 'web' && {
        outlineStyle: 'none' as never,
      }),
    },
    inputMultiline: {
      minHeight: 44,
    },
    errorText: {
      fontSize: 13,
      color: theme.error,
    },
    saveButton: {
      alignSelf: 'flex-start',
      backgroundColor: theme.primary,
      borderRadius: theme.borderRadius.md,
      paddingHorizontal: 16,
      paddingVertical: 10,
      marginTop: 4,
    },
    saveButtonPressed: {
      opacity: 0.85,
    },
    saveButtonDisabled: {
      opacity: 0.5,
    },
    saveButtonText: {
      color: '#fff',
      fontSize: 14,
      fontWeight: '600',
    },
  })
}
